import classNames from "classnames";
import Icon from "../Icon";

import styles from "./Button.module.css";

type Props = {
  size?: "small" | "medium" | "large";
  color?: "black" | "white" | "blue" | "pink" | "transparent";
  width?: "normal" | "full";
  link?: string;
  emoji?: string;
  type?: "button" | "submit";
  isOpenInNewWindow?: boolean;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
};

export const Button = ({
  size = "medium",
  color = "black",
  width = "normal",
  emoji,
  link,
  type = "button",
  isOpenInNewWindow = false,
  disabled,
  loading,
  children,
  onClick,
}: Props) => {
  const isInternalLink = link?.startsWith("/");

  const buttonClass = classNames(
    styles.button,
    size ? styles[`size--${size}`] : false,
    color ? styles[`color--${color}`] : false,
    width ? styles[`width--${width}`] : false,
    loading ? styles["-loading"] : false
  );

  if (link) {
    // Internal link
    if (isInternalLink) {
      return (
        <a href={link} onClick={onClick} className={buttonClass}>
          {children}
          {emoji && (
            <span className={styles.icon}>
              <Icon type={emoji} size="small" />
            </span>
          )}
        </a>
      );
    }

    // External link
    return (
      <a
        onClick={onClick}
        href={link}
        className={buttonClass}
        target={isOpenInNewWindow ? "_blank" : "_self"}
        rel={isOpenInNewWindow ? "noreferrer" : ""}
      >
        {children}
      </a>
    );
  }

  // Button
  return (
    <button
      onClick={onClick}
      className={buttonClass}
      type={type}
      disabled={disabled || loading}
    >
      {emoji && <span className={styles.icon}>{emoji}</span>}
      {children}
    </button>
  );
};
